const normalizeId = (value) => (typeof value === 'string' && value.length > 0 ? value : null);

const normalizeSeatCount = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.trunc(value) : undefined;
  }
  if (typeof value === 'string') {
    if (!value) return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.trunc(parsed) : undefined;
  }
  return undefined;
};

const normalizeBoolean = (value) => (typeof value === 'boolean' ? value : undefined);

export const normalizeTenantId = (value) => normalizeId(value);

export const normalizeTenantCreatePayload = (payload) => {
  return {
    ownerEmail: payload?.ownerEmail,
    organizationName: payload?.organizationName,
    organizationCode: payload?.organizationCode,
    noOfSeats: normalizeSeatCount(payload?.noOfSeats),
  };
};

export const normalizeTenantUpdatePayload = (payload) => {
  const normalized = {};

  if (payload?.organizationOwner !== undefined) {
    normalized.organizationOwner = payload.organizationOwner;
  }

  if (payload?.noOfSeats !== undefined) {
    normalized.noOfSeats = normalizeSeatCount(payload.noOfSeats);
  }

  return normalized;
};

export const normalizeTenantAddonControlPayload = (payload) => {
  const normalized = {};

  if (payload?.collaborationActivated !== undefined) {
    normalized.collaborationActivated = normalizeBoolean(payload.collaborationActivated);
  }

  if (payload?.engagementLogActivated !== undefined) {
    normalized.engagementLogActivated = normalizeBoolean(payload.engagementLogActivated);
  }

  if (payload?.trackerAIActivated !== undefined) {
    normalized.trackerAIActivated = normalizeBoolean(payload.trackerAIActivated);
  }

  return normalized;
};
